import React from 'react';
import update from 'immutability-helper';
import SelectInput from '../misc/SelectInput.js';
import States from '../misc/States.js';

class AdvancedPeopleOptions extends React.Component {
  _cityChanged = (event) => {
    const next = update(this.props.options, {
      city: {$set: event.target.value},
    });
    this.props.onChange(next);
  };

  _roleChanged = (event) => {
    const next = update(this.props.options, {
      role: {$set: event.target.value},
    });
    this.props.onChange(next);
  };

  _sportChanged = (event) => {
    const next = update(this.props.options, {
      sport_id: {$set: event.target.value},
    });
    this.props.onChange(next);
  };

  _stateChanged = (event) => {
    const next = update(this.props.options, {
      state: {$set: event.target.value},
    });
    this.props.onChange(next);
  };

  _teamTypeChanged = (event) => {
    const next = update(this.props.options, {
      team_type: {$set: event.target.value},
    });
    this.props.onChange(next);
  };

  render() {
    const {options, sports} = this.props;
    return (
      <div className="row">
        <div className="col-xs-12 col-xs-offset-0 col-sm-offset-1 col-sm-10">
          <div className="form-group">
            <div className="col-xs-7 col-sm-8">
              <SelectInput className="form-control" value={options.sport_id} onChange={this._sportChanged}>
                <option value="">Sport</option>
                {
                  sports.map(sport => {
                    return (
                      <option key={sport.id} value={sport.id}>{sport.name}</option>
                    );
                  })
                }
              </SelectInput>
            </div>
            {
              /*
              <div className="col-xs-5 col-sm-4">
                <SelectInput className="form-control" value={options.team_type} onChange={this._teamTypeChanged}>
                  <option value="">Level</option>
                  <option value="youth">Youth</option>
                  <option value="club">Club</option>
                  <option value="adult">Adult</option>
                  <option value="highschool">High School</option>
                  <option value="college">College</option>
                </SelectInput>
              </div>
              */
            }
            <div className="col-xs-5 col-sm-4">
              <SelectInput className="form-control" value={options.role} onChange={this._roleChanged}>
                <option value="">Role</option>
                <option value="player">Athlete</option>
                <option value="coach">Coach</option>
                <option value="team_mom">Team Parent</option>
                <option value="parent">Parent</option>
                <option value="media">Media</option>
                <option value="blast_manager">Blast Manager</option>
                <option value="member">Family Member, Friend, or Fan</option>
              </SelectInput>
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-7 col-sm-8">
              <input type="text" className="form-control" placeholder="City" value={options.city || ''} onChange={this._cityChanged}/>
            </div>
            <div className="col-xs-5 col-sm-4">
              <SelectInput className="form-control" value={options.state || ''} onChange={this._stateChanged}>
                <option value="">State</option>
                {
                  States['US'].map(([value, label]) => (<option key={value} value={value}>{label}</option>))
                }
              </SelectInput>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdvancedPeopleOptions;
